module.exports = __webpack_public_path__ + "static/media/236-republic-of-macedonia.ff7d1713.svg";